<template>
  <el-row class="pond-alerts-tab" slot="pondlogs-default-layout-main">
    <el-row type="flex" :gutter="10" class="dashboard-row-1">
      <el-col class="table-container" :span="16">
        <el-row class="alerts-table" type="block">
          <PondAlertsTable :loading="loading" />
        </el-row>
      </el-col>

      <el-col :span="8">
        <el-row>
          <div class="pond-alerts-count">
            <p class="pond-alerts-count__title">{{ $t("total_ponds_with_alerts") }}</p>
            <p class="pond-alerts-count__value">{{ (getPondsHavingAlerts||[]).length }}</p>
          </div>
          <!-- <hr /> -->
        </el-row>
        <el-row class="device-alerts" type="block">
          <DeviceWiseAlerts :loading="loading" />
        </el-row>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DeviceWiseAlerts from "./deviceWiseAlerts";
import PondAlertsTable from "./pondAlertsTable";
import errorHandlerMixin from "@/mixins/errorHandlerMixin.js";
import pondmother from "@/store/components/pondmother";
export default {
  name: "PondAlertsTab",
  mixins: [errorHandlerMixin],
  data: function() {
    return {
      selectedPonds: ["All"],
      loading: true,
      devices: [],
      alerts: [],

      errorAlertDeviceMap: {
        POND_MOTHER: [],
        POND_GUARD: [],
        SHRIMP_TALK: []
      },
      mapFEToBKDevices: {
        POND_MOTHER: "pond_mothers",
        POND_GUARD: "pond_guards",
        SHRIMP_TALK: "shrimp_talks"
      },
      query: {
        location_id: null,
        biomass_units: "KG",
        include: ["title", "pond_mothers", "shrimp_talks", "pond_guards"],
        get_all: true,
        status: ["ACTIVE"]
      }
    };
  },

  components: {
    DeviceWiseAlerts,
    PondAlertsTable
  },
  created() {
    if (!this.$store.hasModule("pondmother")) {
      this.$store.registerModule("pondmother", pondmother);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.hasModule("pondmother")) {
      this.$store.unregisterModule("pondmother");
    }
    next();
  },
  async mounted() {
    console.log(this.alertsFilter);
    await this.initComponent();
  },
  computed: {
    ...mapGetters("user", {
      getCurrUserLocation: "getCurrUserLocation",
      getUserTimeZone: "getUserTimeZone"
    }),
    ...mapGetters("pondmother", {
      getObjPmIdPm: "getObjPmIdPm"
    }),
    ...mapGetters("pond", {
      ponds: "getActivePonds"
    }),
    ...mapGetters("alertsInfo", {
      alertsFilter: "getAlertsFilter",
      getValidErrorAlerts: "getValidErrorAlerts",
      getPondsHavingAlerts: "getPondsHavingAlerts",
      getTotalDeviceWiseAlertsCount: "getTotalDeviceWiseAlertsCount"
    }),

    getTableData() {
      return Object.values(this.errorAlertDeviceMap).flat(1);
    }
  },
  methods: {
    ...mapActions("pondmother", {
      fetchAllPondMothers: "fetchAllPondMothers"
    }),
    ...mapActions("pond", {
      fetchAllPonds: "fetchAllPonds"
    }),
    ...mapActions("alertsInfo", {
      fetchAllAlerts: "fetchAllAlerts"
    }),
    async initComponent() {
      this.loading = true;
      this.query.location_id = this.getCurrUserLocation._id;
      try {
        await this.fetchAllAlerts();
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.pond-alerts-tab {
  @mixin component-font-size($offset_value: 0) {
    @include responsiveProperty(
      font-size,
      $app_font_size_1 + $offset_value,
      $app_font_size_2 + $offset_value,
      $app_font_size_3 + $offset_value
    );
  }
  .er-card {
    border-radius: 5px;
  }
  .pond-alerts-count {
    display: flex;
    align-items: center;
    height: 2 * $app_font_size_small;
    padding: 8px 20px 8px 10px;
    background: white;
    align-items: center;
    justify-content: space-between;
    color: #333333;
    &__title {
      opacity: 0.9;
      color: #0a2463;
      @include responsiveProperty(
        font-size,
        $app_font_size_2,
        $app_font_size_3,
        $app_font_size_xl
      );
    }
    &__value {
      padding-left: 10px;
      border-left: 1px solid #dfebf5;
      color: #e31a1c;
      @include responsiveProperty(
        font-size,
        $app_font_size_2,
        $app_font_size_3,
        $app_font_size_xl
      );
    }
  }
  .dashboard-row-1 {
    overflow: hidden;
    position: relative;
  }
  .el-card {
    border: 0px solid #ebeef5;
  }
  .btns {
    display: flex;
    justify-content: space-between;
    .el-input__inner {
      background: #349aff;
      color: white;
    }
    margin-bottom: 15px;
  }
  .total-alerts {
    margin-bottom: 15px;
  }
}
</style>
